import { render, staticRenderFns } from "./mChebox.vue?vue&type=template&id=3f142c51&scoped=true&"
import script from "./mChebox.vue?vue&type=script&lang=js&"
export * from "./mChebox.vue?vue&type=script&lang=js&"
import style0 from "./mChebox.vue?vue&type=style&index=0&id=3f142c51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f142c51",
  null
  
)

export default component.exports